class FreeShipCountdown {
  constructor(el, target, threshold) {
    this.el = el
    this.threshold = threshold
    this.target = target
    this.countdown = el.querySelector('[data-countdown]')
    this.progress = el.querySelector('[data-progress]')
  }

  init() {
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver

    new MutationObserver(async () => {
      const res = await fetch('/cart.js')
      const json = await res.json()

      let countdownPrice = (this.threshold - json.total_price)
      if((countdownPrice / 100) < 0) countdownPrice = 0

      const percent = countdownPrice / this.threshold

      this.countdown.innerHTML = (countdownPrice / 100).toLocaleString('en-US', {
        style: "currency",
        currency: "USD"
      }).replace('.00', '')

      this.progress.style.width = (100 - (percent * 100)) + '%'
    }).observe(this.target, {
      subtree: true,
      childList: true
    })
  }
}
